import React from 'react';
import { CampusResourcesQuery } from '../../../graphQL';
import {
  BEACON_RESOURCE_METADATA,
  BEACON_RESOURCE_TYPES,
  isBeaconResource,
} from '../constants/beaconResourceMetadata';
import { ResourceSection } from './ResourceSection';

type Props = {
  organizationId: number;
  editable?: boolean;
  resources: CampusResourcesQuery['organization']['resources'];
  refetch: () => Promise<unknown>;
};

export function BeaconResourcesSection({ organizationId, editable, resources, refetch }: Props) {
  return (
    <ResourceSection
      organizationId={organizationId}
      editable={editable}
      verticalDisplay={false}
      resources={resources}
      refetch={refetch}
      metadata={BEACON_RESOURCE_METADATA}
      resourceTypes={BEACON_RESOURCE_TYPES}
      sectionKeyPrefix="beacon"
      resourceValidator={isBeaconResource}
    />
  );
}
